export default __webpack_public_path__ + "static/media/arrow-up.f252b2a0.svg";